<header class="text-white px-4 md:px-6 py-4 flex items-center justify-between shadow-md">
  <!-- Mobile Menu Button -->
  <button
    (click)="toggleMobileMenu()"
    class="lg:hidden p-2 hover:bg-pink-800 rounded-md transition-colors"
    aria-label="Toggle menu"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <h1 class="text-lg md:text-xl font-semibold">BRD Archive</h1>
  <div class="flex items-center gap-2 md:gap-4">
    <button class="p-2 rounded-full transition-colors cursor-pointer">
      <mat-icon>account_circle</mat-icon>
    </button>
  </div>
</header>
